// extracted by mini-css-extract-plugin
export default {"cashbackRightBar":"style_cashbackRightBar__UHmet","description":"style_description__-FbC3"};